import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const HomePixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2022_13590)">
        <path d="M16 45.9998H19.9995V41.9989H24.001V45.9998H28.0005V38H16V45.9998Z" fill={fillColor || 'black'} />
        <path d="M35.9995 38H32V42.0009H35.9995V38Z" fill={fillColor || 'black'} />
        <path
          d="M8.00101 33.9995V30.0006H16V25.9997H8.00101V22.0008H16V17.9999H8.00101V14.001H3.9995V22.0008H0V41.9993H3.9995V46.0002H12.0005V38.0004H16V33.9995H8.00101Z"
          fill={fillColor || 'black'}
        />
        <path d="M36.0015 30.0005H28.0005V34.0014H36.0015V30.0005Z" fill={fillColor || 'black'} />
        <path
          d="M24.001 25.9996V5.99902H16V9.99994H19.9995V14.0009H16V17.9998H19.9995V22.0007H16V25.9996H19.9995V30.0005H16V33.9994H24.001V30.0005H28.0005V25.9996H24.001Z"
          fill={fillColor || 'black'}
        />
        <path d="M44.0005 14.001V33.9995H35.9995V38.0004H40.001V46.0002H44.0005V38.0004H48V14.001H44.0005Z" fill={fillColor || 'black'} />
        <path d="M44.0005 10H35.9995V13.9989H44.0005V10Z" fill={fillColor || 'black'} />
        <path d="M16.002 10H8.00098V13.9989H16.002V10Z" fill={fillColor || 'black'} />
        <path d="M36.0015 5.99902H28.0005V9.99994H36.0015V5.99902Z" fill={fillColor || 'black'} />
        <path d="M28.0005 2H24.001V5.9989H28.0005V2Z" fill={fillColor || 'black'} />
      </g>
      <defs>
        <clipPath id="clip0_2022_13590">
          <rect width="48" height="44" fill={fillColor || 'white'} transform="translate(0 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { HomePixelIcon };
